function paymentRequestAvailable(runtime) {
  return typeof runtime?.PaymentRequest === "function";
}

/**
 * Browser checks only narrow a server-issued wallet capability. They do not
 * claim a merchant is enrolled or that the device has an available wallet.
 */
export function readDigitalWalletRuntimeCapability(methodId, runtime = typeof window === "undefined" ? null : window) {
  const method = String(methodId || "").trim().toLowerCase();
  if (method === "google_pay") {
    return {
      eligible: paymentRequestAvailable(runtime),
      reason: paymentRequestAvailable(runtime) ? "payment_request_available" : "payment_request_unavailable",
    };
  }
  if (method === "samsung_pay") {
    const ua = String(runtime?.navigator?.userAgent || "").toLowerCase();
    const eligible = paymentRequestAvailable(runtime) && ua.includes("android") && ua.includes("samsung");
    return { eligible, reason: eligible ? "eligible_samsung_android" : "samsung_device_or_payment_request_unavailable" };
  }
  return { eligible: true, reason: "not_wallet_method" };
}
